(() => {
  const root = document.querySelector('[data-purpley-klaviyo]');
  if (!root) return;

  const teaser = root.querySelector('[data-purpley-klaviyo-open]');
  const backdrop = root.querySelector('[data-purpley-klaviyo-backdrop]');
  const dialog = root.querySelector('[role="dialog"]');
  const form = root.querySelector('[data-purpley-klaviyo-form]');
  const email = form?.querySelector('input[type="email"]');
  const submit = form?.querySelector('button[type="submit"]');
  const status = root.querySelector('[data-purpley-klaviyo-status]');
  const success = root.querySelector('[data-purpley-klaviyo-success]');
  const storageKey = 'purpley:klaviyo-popup:dismissed-at';
  const dismissForMs = 3 * 24 * 60 * 60 * 1000;
  let lastFocus;

  document.body.classList.add('purpley-klaviyo-managed');

  const cookieBannerIsOpen = () => Boolean(document.querySelector('#CookieBanner[active]'));
  const stickyCard = () => document.querySelector('.product-sticky-form--h6 .product-sticky-form__card');

  const legacySignupUi = () => {
    document.querySelectorAll('button[aria-label="Close teaser"]').forEach((button) => {
      const legacyTeaser = button.closest('[role="dialog"]') || button.parentElement;
      if (legacyTeaser) legacyTeaser.style.setProperty('display', 'none', 'important');
    });
  };

  const teaserWasRecentlyDismissed = () => {
    const dismissedAt = Number.parseInt(localStorage.getItem(storageKey) || '0', 10);
    return Number.isFinite(dismissedAt) && Date.now() - dismissedAt < dismissForMs;
  };

  const placeAbovePurchaseBar = () => {
    if (root.hidden || !teaser) return;
    const sticky = stickyCard();
    const visible = sticky
      && getComputedStyle(sticky).visibility !== 'hidden'
      && Number.parseFloat(getComputedStyle(sticky).opacity || '0') > 0;
    const offset = visible ? sticky.getBoundingClientRect().height + 16 : 0;
    teaser.style.bottom = `calc(max(1rem, env(safe-area-inset-bottom)) + ${Math.ceil(offset)}px)`;
  };

  const showTeaserWhenReady = () => {
    if (teaserWasRecentlyDismissed()) return;
    if (cookieBannerIsOpen()) {
      window.setTimeout(showTeaserWhenReady, 700);
      return;
    }
    root.hidden = false;
    placeAbovePurchaseBar();
  };

  const focusableElements = () => [...dialog.querySelectorAll(
    'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
  )];

  const open = () => {
    lastFocus = document.activeElement;
    backdrop.hidden = false;
    document.body.classList.add('purpley-klaviyo-open');
    window.requestAnimationFrame(() => email?.focus());
  };

  const close = ({ remember = true } = {}) => {
    backdrop.hidden = true;
    document.body.classList.remove('purpley-klaviyo-open');
    if (remember) localStorage.setItem(storageKey, String(Date.now()));
    lastFocus?.focus?.();
  };

  const onDialogKeydown = (event) => {
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = focusableElements();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    }
    else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const subscribe = async (address) => {
    const companyId = root.dataset.companyId;
    const listId = root.dataset.listId;
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Purpley storefront 5% popup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: address,
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } },
                },
              },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: listId } },
        },
      },
    };
    const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`, {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: '2026-07-15',
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error('Klaviyo subscription failed');
  };

  teaser?.addEventListener('click', open);
  root.querySelectorAll('[data-purpley-klaviyo-close]').forEach((button) => {
    button.addEventListener('click', () => close());
  });
  backdrop?.addEventListener('click', (event) => {
    if (event.target === backdrop) close();
  });
  dialog?.addEventListener('keydown', onDialogKeydown);
  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    status.textContent = '';
    if (!email.checkValidity()) {
      email.reportValidity();
      return;
    }
    submit.disabled = true;
    submit.textContent = 'Se trimite…';
    try {
      await subscribe(email.value.trim());
      form.hidden = true;
      success.hidden = false;
      localStorage.setItem(storageKey, String(Date.now()));
      success.querySelector('button')?.focus();
    }
    catch (_error) {
      status.textContent = 'Nu am putut finaliza înscrierea. Te rugăm să încerci din nou.';
      submit.disabled = false;
      submit.textContent = 'Trimite-mi codul';
    }
  });

  new MutationObserver(() => {
    legacySignupUi();
    placeAbovePurchaseBar();
  }).observe(document.body, { childList: true, subtree: true, attributes: true });
  window.addEventListener('scroll', placeAbovePurchaseBar, { passive: true });
  window.addEventListener('resize', placeAbovePurchaseBar, { passive: true });

  legacySignupUi();
  window.setTimeout(showTeaserWhenReady, 5000);
})();

